<template>
    <div>
        <GmapMap ref="gmap" :center="center" :zoom="12" :map-type-id="mapType" :style="'height: ' + height + 'px'">

            <gmap-custom-marker :key="index" v-for="(m, index) in markers" :marker="m.position">
              <img v-if="!m.type || m.type !== 'team'" src="/img/map/plain-marker.svg" width="32"/>
              <div v-if="!m.text" class="text">{{ index + 1 }}</div>

              <div v-if="m.type === 'team'"class="text" align="center" style="background-color: #34aeeb; padding: 5px; opacity: .60; min-width: 90px;">
                <div style="font-size: 0.95em"><b>{{ m.text }}</b></div>
                <div style="font-size: 0.75em">score={{ m.score }}</div>
                <div style="font-size: 0.6em"><em>{{ m.creationDate }}</em></div>
              </div>
              <div v-else class="text" >{{ m.text }}</div>
            </gmap-custom-marker>

        </GmapMap>
    </div>
</template>

<script>
  import GmapCustomMarker from 'vue2-gmap-custom-marker'

export default {
    name: 'MapPreviewer',
    props: {
      markers: null,
      center: {},
      mapType: '',
      height: ''
    },
    components: {
      'gmap-custom-marker': GmapCustomMarker
    },
    data() {
      return {
        map: null,
      }
    },
    mounted() {
      this.updateMapZoom()
    },
    updated() {
      this.updateMapZoom()
    },
    methods: {
      updateMapZoom() {
        this.$refs.gmap.$mapPromise.then((map) => {
          const bounds = new google.maps.LatLngBounds()
          for (let m of this.markers) {
            bounds.extend(m.position)
          }

          map.fitBounds(bounds)
          map.panToBounds(bounds)
        })
      },
    }
  }
</script>

<style scoped>
    .text{
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 14px;
        font-weight: bold;
        color: white;
        transform: translate(-50%,-75%);
        -ms-transform: translate(-50%,-75%);
    }
</style>
